











































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { UserSendPhoneVerificationRequestModel } from '../../../models/user-request.model'
import { AuthService } from '../../../services/auth.service'
import QForm from 'quasar/src/components/form/QForm.js';
import { ModelSync, Prop } from 'vue-property-decorator'

@Component({
  components: { BaseButton, BaseInput }
})
export default class UserPhoneEditForm extends Vue {
  constructor(
    private readonly service: AuthService
  ) {
    super()
  }

  $refs!: {
    nameUpdateForm: QForm,
  }

  @ModelSync('value', 'input', { default: '0' }) phoneValue!: string
  @Prop({ default: ' تلفن همراه' }) label !: string
  editLoading = false
  primaryPhone = this.phoneValue

  get phoneNumber() {
    return this.phoneValue?.substring(1) || ''
  }

  set phoneNumber(value) {
    this.phoneValue = ('0' + value).replaceAll(' ', '')
  }

  editPhoneVerification() {
    this.$refs.nameUpdateForm.validate().then(success => {
      if (success) {
        this.editLoading = true
        this.service.resendVerificationSmsCode(
          { phone: this.phoneValue } as UserSendPhoneVerificationRequestModel
        ).then(() => {
          this.editLoading = false
          this.$emit('submit', true)
        }).catch(() => {
          this.editLoading = false
          this.$emit('input')
          this.$emit('submit', false)
        })
      }
    })
  }
}
